var golfCourseImg = "/home/circleci/app/src/assets/img/golfCourse.jpg";

export { golfCourseImg as default };
